/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import PropTypes from 'prop-types';

// Component imports
import JsonView from '@uiw/react-json-view';
import { CopyOutlined } from '@ant-design/icons';

// Misc imports

const JsonViewer = ({
  jsonObject
}) => {
  return (
    <JsonView
      displayDataTypes={false}
      value={jsonObject}
      style={{ backgroundColor: 'transparent' }}
    >
      <JsonView.Copied
        render={({ 'data-copied': copied, style, onClick, ...props }, { value }) => {
          const styl = { whiteSpace: 'nowrap' };
          if (copied) {
            return <span style={{ ...style, ...styl }} className="position-relative">
              <CopyOutlined className="fs-lg text-success" />
            </span>;
          }
          return <span style={{ ...style, ...styl }} onClick={onClick}><CopyOutlined className="fs-lg" /></span>;
        }}
      />
    </JsonView>
  );
};

JsonViewer.propTypes = {
  jsonObject: PropTypes.arrayOf([PropTypes.object, PropTypes.array])
};

export default JsonViewer;
